export const getTrimmedValue = (value: string, maxLength: number, trimmedLength: number, variant: TrimVariant) => {
  if (value.length < maxLength) {
    return value
  }

  if (variant === TrimVariant.IN) {
    return value.slice(0, trimmedLength / 2) + '...' + value.slice(-trimmedLength / 2)
  }

  if (variant === TrimVariant.POST) {
    return value.slice(0, trimmedLength) + '...'
  }

  if (variant === TrimVariant.PRE) {
    return '...' + value.slice(-trimmedLength)
  }
}

export enum TrimVariant {
  PRE,
  IN,
  POST,
}
